import { authApi as e } from "@maat/api-main";
//#region src/phone/runPhoneOtpSend.ts
var t = async (t) => {
	let n = await e.phoneChallenge();
	if (!n.challenge_required || !n.challenge || !n.challenge_token) return;
	let r = await t(n.challenge, n.difficulty ?? 0);
	return {
		challenge_token: n.challenge_token,
		nonce: r
	};
};
//#endregion
export { t as resolvePowSolution };
